import { ApplicationState } from '@/redux/store'
import { put, select } from 'redux-saga/effects'
import { createQuickReplyAction, fetchRepliesByCompanyAction } from '../../handles'
import { create } from '../_http/reply'

export function* createQuickReplySaga(action: ReturnType<typeof createQuickReplyAction.request>) {
  const quickReply = action.payload
  try {
    yield create(quickReply)
    yield put(createQuickReplyAction.success())

    const companyState = yield select((state: ApplicationState) => state.companyReducer)

    yield put(fetchRepliesByCompanyAction.request({ companyId: companyState?.selectedCompany, operatorId: null }))
  } catch (error) {
    yield put(createQuickReplyAction.failure())
  }
}
